/**
 * Canonical conversion copy for scan and booking actions across the landing app.
 *
 * Scan CTAs intentionally use two tiers: jump actions move the reader to the
 * scanner, while submit actions start the scan. Keeping the strings here makes
 * that distinction explicit and prevents individual surfaces from drifting.
 */
export const SCAN_JUMP_CTA_LABEL = 'Scan my site';
export const SCAN_SUBMIT_CTA_LABEL = 'Start free scan';
export const SCAN_CARD_HEADING = 'See your visibility in 45 seconds';
export const SCAN_TRUST_LINE = 'Free · 45 seconds · No credit card required';

/** Contact entry points are personal ("Talk to us", 2026-07-16 Nathan review);
 * in-modal actions keep the concrete verb + duration. */
export const BOOKING_CTA_LABEL = 'Talk to us';
export const BOOKING_SHORT_CALL_LABEL = 'Book a 15m call';
/** Matches the button that opens it: every "Talk to us" opens this form. */
export const BOOKING_MODAL_TITLE = 'Talk to Nathan';
export const BOOKING_MODAL_LEDE = 'Every message gets a reply within 24 hours.';
export const BOOKING_REQUEST_CTA_LABEL = 'Send message';
export const BOOKING_NOTE_LABEL = 'What would you like help with?';
/** The form's footer link to the calendar, which switches views without submitting. */
export const BOOKING_CALL_INSTEAD_LABEL = 'Book a 15m call instead';
/** The calendar's way back to the form, on every page. */
export const CALENDAR_MESSAGE_LABEL = 'Message Nathan instead';
